// extracted by mini-css-extract-plugin
export var authorName = "Bio-module--authorName--fe401";
export var bio = "Bio-module--bio--be820";
export var bioAvatar = "Bio-module--bioAvatar--1c2d6";
export var bioBody = "Bio-module--bioBody--466ab";
export var heading = "Bio-module--heading--0ca6f";